import * as Sentry from '@sentry/react';
import { IS_DEV, SENTRY_ENV } from './src/constants/common';

// IF SENTRY_ENV isn't defined, don't set sentry, otherwise it'll default to live. This case could occur for local, since .env.development doesn't have (AND SHOULDN't) VITE_REACT_SENTRY_ENV set
if (!IS_DEV && SENTRY_ENV) {
    Sentry.init({
        dsn: 'https://b1c5cdf381482281250a13fe56617e91@o1406267.ingest.us.sentry.io/4509348648189952',

        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
        sendDefaultPii: true,

        ignoreErrors: [
            // This type of error is thrown by some Android WebView bridge implementations when postEvent/post is unavailable. We can ignore these errors to avoid polluting Sentry with unnecessary noise.
            'Error invoking postEvent: Method not found',

            // Firefox-specific error thrown when a browser extension (e.g. a password manager) holds a reference
            // to a DOM node from a page that has since been torn down (e.g. after a window.location.replace navigation).
            // Not actionable on our end, see https://bugzilla.mozilla.org/show_bug.cgi?id=1671416
            /can'?t access dead object/i,
        ],

        integrations: [
            Sentry.thirdPartyErrorFilterIntegration({
                filterKeys: ['victron-energy-professional'],

                // Defines how to handle errors that contain third party stack frames.
                // Possible values are:
                // - 'drop-error-if-contains-third-party-frames'
                // - 'drop-error-if-exclusively-contains-third-party-frames'
                // - 'apply-tag-if-contains-third-party-frames'
                // - 'apply-tag-if-exclusively-contains-third-party-frames'
                behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
            }),
        ],
        // Session Replay - Disabled for legal reasons
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        environment: SENTRY_ENV,
    });
}
